import { render, staticRenderFns } from "./cadmensagensautomaticas.vue?vue&type=template&id=7a05ae05&"
import script from "./cadmensagensautomaticas.vue?vue&type=script&lang=js&"
export * from "./cadmensagensautomaticas.vue?vue&type=script&lang=js&"
import style0 from "./cadmensagensautomaticas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports